var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Icon__StyledIcon-sc-1det6wr-0 jgtlcI",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.893 5.807l.113-.007a.9.9 0 01.893.787l.007.113-.001 8.393 2.419-2.41a.905.905 0 011.09-.06l.096.076c.34.304.395.807.146 1.174l-.076.097-3.864 3.933a.904.904 0 01-1.255.086l-4.049-4.02a.898.898 0 01.066-1.27.904.904 0 011.186-.02l2.441 2.368V6.7a.9.9 0 01.788-.893l.113-.007-.113.007z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.b57ef8c7bcb55284c7ebd29cc8102d68.svg";
export { ForwardRef as ReactComponent };